import React from "react";

import Line from "components/Tvendo/Article/DataMaster/Line/List.js";

export default function () {
  return <Line />;
}
